// extracted by mini-css-extract-plugin
module.exports = {"CashTips":"cashTips_CashTips__2v3-E","CashTipsHeading":"cashTips_CashTipsHeading__1CoLF"};